import {
  Component, Input, Output, EventEmitter, AfterViewInit, OnChanges, SimpleChange
} from "@angular/core";
import {Funcoes} from "../../funcoes";

declare let $:any;

@Component({
  selector: 'widget-boolean',
  template: `<div
                [formGroup]="form"
                [class.has-error]="form.controls[id] && form.controls[id].touched && !form.controls[id].valid"
                [class.has-feedback]="form.controls[id] && form.controls[id].touched && !form.controls[id].valid">
                <label class="control-label text-right {{labelClass}}" for="{{id}}" [class.active]="model" *ngIf="comLabel">{{ txtLabel | translate }}</label>
                <div class="{{containerInputClass}}">
                  <input type="checkbox" class="{{uid}}"
                   id="{{id}}"
                   [(ngModel)]="model"
                   formControlName="{{id}}">
                  <div class="form-control-feedback" *ngIf="form.controls[id] && form.controls[id].touched && !form.controls[id].valid">
                    <i class="icon-cancel-circle2"></i>
                  </div>
                  
                  <ng-template [ngIf]="form.controls[id] && form.controls[id].errors">
                    <span class="help-block" *ngIf="form.controls[id].touched && !form.controls[id].valid && !form.controls[id].errors[id]">{{txt_default_erro}}</span>
                    <div *ngIf="!form.controls[id].valid">
                      <span class="help-block" *ngFor="let erro of form.controls[id].errors[id] | keysBack">{{ 'back.'+erro.key | translate:erro.replace }}</span>
                    </div>
                  </ng-template>
                </div>
              </div>`,
})

export class WidgetBooleanComponent implements OnChanges, AfterViewInit {

  @Input()
  id: string = '';

  @Input()
  model: any = '';

  @Output() modelChange = new EventEmitter<string>();

  @Input()
  form: any;

  @Input()
  txt_default_erro: any;

  @Input()
  txtLabel: string = '';

  @Input()
  labelClass: string = 'col-sm-2';

  @Input()
  containerInputClass: string = 'col-sm-10';

  @Input()
  txt_sim: any = 'Sim';

  @Input()
  txt_nao: any = 'Não';

  @Input()
  readonly: boolean = false;

  @Input()
  comLabel: boolean = true;

  @Input()
  toggleWidth: any = null;

  @Input()
  inverterCor: boolean = false;

  uid: any;

  constructor(public func: Funcoes){
    this.uid = func.guid();
  }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}) {
    for (let change in changes) {
      if(change == 'model'){
        let element = $('.'+this.uid);
        let wasDisabled = element.prop('disabled');
        if (wasDisabled) {
          element.bootstrapToggle('enable');
        }
        element.prop('checked', changes[change].currentValue).change();
        if (wasDisabled) {
          element.bootstrapToggle('disable');
        }
      }else if(change == 'readonly'){
        if(changes[change].currentValue){
          $('.'+this.uid).bootstrapToggle('disable');
        }else{
          $('.'+this.uid).bootstrapToggle('enable');
        }
      }
    }
  }

  ngAfterViewInit() {
    let self = this;
    let width = self.toggleWidth || null;
    if (!width) {
      let maxLen = Math.max((self.txt_sim || '').length, (self.txt_nao || '').length);
      if (maxLen > 3) {
        width = 135;
      }
    }

    $('.'+self.uid).bootstrapToggle({
      on: self.txt_sim,
      off: self.txt_nao,
      onstyle: self.inverterCor ? "danger" : "success",
      offstyle: self.inverterCor ? "success" : "danger",
      width: width
    }).change(function () {
      self.update($(this).prop('checked'))
    });

    if(this.readonly){
      $('.'+this.uid).bootstrapToggle('disable');
    }
  }

  update(val : boolean) {
    this.model = val;
    this.modelChange.emit(this.model);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/form/widget-boolean.component.ts